const PRODUCT_TILE = [175, 315];
const THUMBNAIL_PRODUCT_MEDIA_ITEM = 48;

const getProductTileSize = () => PRODUCT_TILE;

export {
    PRODUCT_TILE, getProductTileSize, THUMBNAIL_PRODUCT_MEDIA_ITEM
};
